import React from "react";
import "../design-system/tokens.css";
import "./FlightEngineShell.css";
import FlightProgress from "./FlightProgress";

/**
 * Shared chrome for Flight Engine V2 preview / future production UI.
 * Presentation only — no booking state.
 */
export default function FlightEngineShell({
  step,
  title,
  subtitle = null,
  showProgress = false,
  searchSummary = null,
  sidebar = null,
  children,
  previewNav = null,
  bare = false,
}) {
  return (
    <div className="fe2 fe2-shell">
      {previewNav}
      <div className="fe2-shell__frame">
        {!bare ? (
          <header className="fe2-shell__top">
            <div className="fe2-shell__brand-block">
              <span className="fe2-shell__product">HotelsRiver · מנוע טיסות</span>
              <h1 className="fe2-shell__title">{title}</h1>
              {subtitle ? <p className="fe2-shell__subtitle">{subtitle}</p> : null}
            </div>
            {searchSummary}
          </header>
        ) : null}

        {showProgress ? <FlightProgress activeStep={step} /> : null}

        <div
          className={
            sidebar
              ? "fe2-shell__workspace fe2-shell__workspace--with-sidebar"
              : "fe2-shell__workspace"
          }
        >
          {sidebar ? (
            <aside className="fe2-shell__sidebar">{sidebar}</aside>
          ) : null}
          <main className="fe2-shell__main">{children}</main>
        </div>
      </div>
    </div>
  );
}
